import { css } from '@linaria/core';
export const buttonWrapper = "odules__Apps__components__ConsentAcceptOverlay__styles_ts-buttonWrapper-b1y6qyih";
export const consentMessageWrapper = "odules__Apps__components__ConsentAcceptOverlay__styles_ts-consentMessageWrapper-c1viq008";
export const wrapper = "odules__Apps__components__ConsentAcceptOverlay__styles_ts-wrapper-w13pehd8";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");